export default class Modal {
  constructor(modalId) {
    this.modalId = modalId;
    this.$form = document.getElementById(modalId.replace("modal", "form"));
    this.initialized = false;
    this.prefillData = null;
    this.currentData = null;
    this.setupModal();
    this.setupOnSubmitListener();
    this.setupTutorials();
  }

  setupTutorials() {
    const $btn = this.$modal._element.querySelector(
      '[data-action="video-tutorial"]'
    );
    if ($btn) {
      $btn.addEventListener("click", () => {
        if (typeof this.videoTutorials === "undefined") {
          return;
        }
        let tutorialLink;
        const currentLanguage = this.getCurrentLanguage();
        if (typeof this.videoTutorials[currentLanguage] !== "undefined") {
          tutorialLink = this.videoTutorials[currentLanguage];
        } else {
          tutorialLink =
            this.videoTutorials[Object.keys(this.videoTutorials)[0]];
        }

        peque.showTutorialModal(tutorialLink);
      });
    }
  }

  getCurrentLanguage() {
    if (typeof currentUser !== "undefined") {
      return currentUser.language;
    }
    return location.pathname.split("/")[1];
  }

  setupOnSubmitListener() {
    if (this.$form != null) {
      this.$form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.validateAndSendForm();
      });
    }
  }

  enableSubmitButton(enable) {
    if (!this.$submitButton) {
      return;
    }
    if (enable) {
      this.$submitButton.removeAttribute("disabled");
    } else {
      this.$submitButton.disabled = "disabled";
    }
  }

  hideOpenTooltips() {
    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
      bootstrap.Tooltip.getInstance(el)?.hide();
    });
  }

  setupModal() {
    this.$modal = new bootstrap.Modal(document.getElementById(this.modalId));
    this.$submitButton = this.$modal._element.querySelector('[type="submit"]');

    const getHashIds = () => window.location.hash.replace("#", "").split("&");

    this.$modal._element.addEventListener("show.bs.modal", () => {
      this.hideOpenTooltips();
      if (!getHashIds().includes(this.modalId)) {
        window.location.hash += window.location.hash
          ? `&${this.modalId}`
          : `#${this.modalId}`;
      }
      if (this.initialized) {
        this.whenReady();
      }
    });
    this.$modal._element.addEventListener("hide.bs.modal", () => {
      const hash = getHashIds()
        .filter((h) => h !== this.modalId)
        .reduce((current, h) => {
          return current ? `${current}&${h}` : h;
        }, "");
      const url = window.location.href.split("#")[0];
      peque.navigation.fakePush(`${url}#${hash}`);
      this.enableSubmitButton(true);
    });
    this.$modal._element.addEventListener("hidden.bs.modal", () => {
      if (
        !document.body.classList.contains("modal-open") &&
        document.querySelectorAll(".modal.show").length > 0
      ) {
        document.body.classList.add("modal-open");
      }
    });

    this.$modal._element.addEventListener("shown.bs.modal", () => {
      const $focus = this.$modal._element.querySelector(
        '[autofocus="autofocus"]'
      );

      if ($focus) {
        $focus.focus();
      }
    });
    window.addEventListener("hashchange", () => {
      if (!getHashIds().includes(this.modalId)) {
        this.hide();
      }
    });

    // js vanilla reset does not reset hidden fields...
    this.$form?.addEventListener("reset", () => {
      this.$form.querySelectorAll('input[type="hidden"]').forEach((el) => {
        el.value = "";
      });
    });

    this.$modal._element.querySelectorAll("input[max]").forEach((el) => {
      el.addEventListener("input", () => {
        const type = el.dataset.type ? el.dataset.type : "int";
        const amount =
          type === "int" ? parseInt(el.value) : parseFloat(el.value);
        const maxAmount =
          type === "int" ? parseInt(el.max) : parseFloat(el.max);

        if (amount > maxAmount) {
          el.value = el.max;
        }
      });
    });
  }

  getModal() {
    return this.$modal._element;
  }

  show() {
    this.$modal.show();
  }

  hide() {
    this.$modal.hide();
  }

  setPrefillData(data) {
    this.prefillData = data;
  }

  whenReady() {
    this.initialized = true;
    this.currentData = null;

    if (this.prefillData !== null) {
      this.currentData = { ...this.prefillData };
      this.$form.reset();

      // Reset radios
      this.$form
        .querySelectorAll('[type="radio"] + label.active')
        .forEach((label) => {
          label.classList.remove("active");
        });

      this.prefillForm(this.currentData, this.formFields);
      this.prefillData = null;
    } else {
      try {
        this.$form.querySelector('[name="date"]').valueAsDate = new Date();
      } catch (e) {}
    }
  }

  getInt(fieldName, el) {
    if (typeof el === "undefined") {
      el = this.$form.querySelector('[name="' + fieldName + '"]');
    }
    if (typeof el.autonumeric !== "undefined") {
      return el.autonumeric.getNumber();
    }
    return parseInt(el.value) || null;
  }

  getFloat(fieldName, el) {
    if (typeof el === "undefined") {
      el = this.$form.querySelector('[name="' + fieldName + '"]');
    }

    if (typeof el.autonumeric !== "undefined") {
      return el.autonumeric.getNumber();
    }
    return parseFloat(el.value) || null;
  }

  getString(fieldName) {
    return this.$form.querySelector('[name="' + fieldName + '"]').value;
  }

  getBoolean(fieldName) {
    const $checked = this.$form.querySelector(
      '[name="' + fieldName + '"]:checked'
    );
    if ($checked) {
      return parseInt($checked.value);
    }
    return 0;
  }

  setInt(fieldName, val) {
    const el = this.$form.querySelector('[name="' + fieldName + '"]');
    val = parseInt(val);

    if (typeof el.autonumeric !== "undefined") {
      setTimeout(() => {
        el.autonumeric.set(val);
      }, 100);
      return el.autonumeric.set(val);
    }
    el.value = val;
  }

  setFloat(fieldName, val) {
    const el = this.$form.querySelector('[name="' + fieldName + '"]');
    if (typeof el.autonumeric !== "undefined") {
      setTimeout(() => {
        el.autonumeric.set(val);
      }, 100);
      return el.autonumeric.set(val);
    }
    el.value = val;
  }

  setupNumericFields() {
    this.$form.querySelectorAll("[data-money-field]").forEach((el) => {
      if (typeof el.autonumeric !== "undefined") {
        return;
      }
      el.autonumeric = new AutoNumeric(el, {
        digitGroupSeparator: window.localeDetails.thousands_sep,
        decimalCharacter: window.localeDetails.decimal_point,
        decimalCharacterAlternative: window.localeDetails.decimal_point,
        allowDecimalPadding: 2,
        decimalPlaces: 7,
      });
    });

    this.$form.querySelectorAll("[data-integer-field]").forEach((el) => {
      if (typeof el.autonumeric !== "undefined") {
        return;
      }
      el.autonumeric = new AutoNumeric(el, {
        digitGroupSeparator: window.localeDetails.thousands_sep,
        decimalCharacter: window.localeDetails.decimal_point,
        decimalCharacterAlternative: window.localeDetails.decimal_point,
        decimalPlaces: 0,
      });
    });
  }

  getField(fieldName) {
    return this.$form.querySelector('[name="' + fieldName + '"]');
  }

  prefillForm(entry, fieldsConversion) {
    try {
      this.clearDocuments();
    } catch (e) {}

    Object.keys(fieldsConversion).forEach((k) => {
      const field = fieldsConversion[k];
      const val = entry[field.name];

      if (
        val == null ||
        (val == 0 && field.fieldType !== "checkbox") ||
        val === undefined
      ) {
        return;
      }

      if (typeof field.prefill != "undefined" && !field.prefill) {
        return;
      }

      field.fieldName = field.name.replaceAll("_", "-");

      // special cases
      if (field.varType === "simple-array") {
        switch (field.name) {
          case "documents":
            val.forEach((doc) => {
              this.addDocument(
                doc.id,
                doc,
                this.$documentSelector,
                this.$form.querySelector('[data-container="documents"]')
              );
            });
            break;
        }
        return;
      }

      const $el = this.$form.querySelector('[name="' + field.fieldName + '"]');

      if ($el === null) {
        if (!field.mayNotExist) {
          console.error("Missing field " + field.fieldName);
        }
        return;
      }

      let elementType = $el.tagName.toLowerCase();

      if (elementType === "input") {
        elementType = $el.type.toLowerCase();
      }

      switch (elementType) {
        case "radio":
          this.$form
            .querySelector(
              '[name="' + field.fieldName + '"][value="' + val + '"]'
            )
            .click();
          break;
        case "boolean":
          $el.checked = true;
          break;
        case "toggle":
          this.$form
            .querySelector('[name="' + field.fieldName + '-toggle"]')
            .click();
          $el.value = val;
          break;
        default:
          if (typeof $el.dataset.moneyField != "undefined") {
            this.setFloat($el.name, val);
          } else if (typeof $el.dataset.integerField != "undefined") {
            this.setInt($el.name, val);
          } else {
            $el.value = val;
          }
          break;
      }

      if (typeof field.trigger !== "undefined") {
        const event = new Event(field.trigger);
        $el.dispatchEvent(event);
      }
    });
  }

  showErrorOnField(message, el) {
    if (!el) {
      throw "Element not found";
    }
    el.classList.add("is-invalid");
    el.title = message;
    el.dataset.bsOriginalTitle = message;

    const tooltip = bootstrap.Tooltip.getOrCreateInstance(el, {
      placement: "bottom",
      container: "body",
      animation: true,
    });
    tooltip.show();
  }

  getFields(fields) {
    return new Promise((resolve, reject) => {
      this.validateFieldSettings(fields);
      resolve(this.validateFields(fields));
    });
  }

  validateField(field, i) {
    let fieldEl = typeof i === "undefined" ? field.el : field.el[i];
    let val;

    if (fieldEl === null) {
      if (field.mayNotExist) {
        return null;
      }
      console.error(field, i);
      throw "Field not found";
    }

    switch (field.fieldType) {
      case "checkbox":
        val = this.getBoolean(field.el.name);
        break;
      case "radio":
        const $selectedRadio = this.$form.querySelector(
          '[name="' + field.el.name + '"]:checked'
        );
        val = $selectedRadio === null ? null : $selectedRadio.value;
        break;
      default:
        val = fieldEl.value || null;
        break;
    }

    if (field.required && (val === null || val.length < 1)) {
      throw {
        el: fieldEl,
        message: "this field is mandatory",
      };
    }

    switch (field.varType) {
      case "int":
        val = this.getInt(fieldEl.name, fieldEl);

        if (isNaN(val)) {
          throw {
            el: fieldEl,
            message: "this field must be numeric",
          };
        }
        break;
      case "float":
        val = this.getFloat(fieldEl.name, fieldEl);
        break;
    }

    if (field.required) {
      switch (field.varType) {
        case "int":
          if (val < 1) {
            throw {
              el: fieldEl,
              message: "this field is mandatory",
            };
          }
          break;
      }
    }
    return val;
  }

  validateFields(fields, e) {
    let entry = {};

    fields.forEach((field) => {
      if (field.varType === "simple-array") {
        const clone = JSON.parse(JSON.stringify(field));
        clone.el = field.el;
        clone.varType = clone.type;

        entry[field.name] = [];
        for (let i = 0; i < field.el.length; i++) {
          entry[field.name].push(this.validateField(clone, i));
        }
      } else if (field.varType === "array") {
        entry[field.name] = [];

        for (let i = 0; i < field.fields[0].el.length; i++) {
          entry[field.name].push(this.validateFields(field.fields, i));
        }

        if (typeof field.validation !== "undefined") {
          field.validation(field, entry);
        }
      } else if (typeof field.validation !== "undefined") {
        field.validation(field, entry, e);
      } else {
        entry[field.name] = this.validateField(field, e);
      }
    });

    return entry;
  }

  validateFieldSettings(fields, fromArray) {
    this.resetFailedValidations();

    fields.forEach((field) => {
      if (typeof field.selector === "undefined") {
        field.selector = field.name.replaceAll("_", "-");
      }
      if (typeof field.fieldType === "undefined") {
        field.fieldType = "input";
      }
      if (typeof field.required === "undefined") {
        field.required = false;
      }
      if (typeof field.mayNotExist === "undefined") {
        field.mayNotExist = false;
      }

      if (field.varType === "array") {
        this.validateFieldSettings(field.fields, true);
      } else {
        if (fromArray === true || field.varType === "simple-array") {
          field.el = this.$form.querySelectorAll(
            '[name="' + field.selector + '[]"]'
          );
        } else {
          field.el = this.$form.querySelector(
            '[name="' + field.selector + '"]'
          );

          if (field.el && field.el.type === "radio") {
            field.fieldType = field.el.type;
          }
        }
      }
    });
  }

  resetFailedValidations() {
    this.$form.querySelectorAll(".is-invalid").forEach((el) => {
      el.classList.remove("is-invalid");

      // hide tooltip
      el.title = "";
      el.dataset.bsOriginalTitle = "";
    });
  }

  getFormModifiedFields(modifiedFields) {
    const getDefaultValue = (value) => {
      return value === null
        ? ""
        : Array.isArray(value) && value.length === 0
        ? ""
        : typeof value === "object" && Object.keys(value).length === 0
        ? ""
        : value;
    };

    return Object.entries(modifiedFields)
      .filter(([field, value]) => {
        return (
          getDefaultValue(this.currentData[field]) !== getDefaultValue(value)
        );
      })
      .reduce((current, [field, value]) => {
        return {
          ...current,
          [field]: { newValue: value, value: this.currentData[field] },
        };
      }, {});
  }
}
